import { IInsurance } from '@AMIEWEB/MarginTool/Components/Assignments/helper';
import {
  IAddScenarioForm as IPlacementMarginAddScenarioForm,
  IScenarioSplit as IPlacementMarginScenarioSplit,
} from '@AMIEWEB/MarginTool/Components/PayPackage/AddScenario/model';
import { IMarginUpdateResponse as IPlacementMarginUpdateResponse } from '@AMIEWEB/MarginTool/Components/PayPackage/models/AddScenarioModal';
import { IGsaHousingDetailsSuymmaryResponse as IPlacementMarginGsaHousingDetailsSuymmaryResponse } from '@AMIEWEB/MarginTool/Components/PayPackage/models/PayPackage';
import { ITypeAheadOption } from '@AMIEWEB/Tasks/CustomComponents/ControlledTypeAheadWithAvatar';

export interface IPeopleSoftValues {
  splitId?: number;
  vms: string | null;
  orientationHours: string | null;
  other: string | null;

}

export interface IPlacementMarginAddScenario {
  placementId: number;
  placementActivityTypeId: number;
  placementStatusId: number;
  placementStatus: string;
  isInExtension: boolean;
  payCycleStartDayNum?: number | null;
  payCycleEndDayNum?: number | null;
  payCycleStartDay: string | null;
  payCycleEndDay: string | null;
  extensionStatusId: number | null;
  extensionStatus: string;
  startDate: string;
  endDate: string;
  duration: number;
  tla: boolean;
  shiftId: number | null;
  shiftDescription: string;
  placementStartDate: string;
  placementEndDate: string;
  placementDuration: number | null;
  scenarioName: string;
  notes?: string;
  isExtensionFromPriorPlacementId?: boolean;
  extensionOfPriorPlacementId?: number;
  payCycleShiftType?: string;
  shiftList?: IPlacementMarginShiftListItem[];
  payCycleShiftDetails?: IPlacementMarginPayCycleShiftDetail[];
}

export interface IPlacementMarginAddExtension {
  placementId: number;
  placementActivityTypeId: number;
  placementStatusId: number;
  placementStatus: string;
  isInExtension: boolean;
  extensionName: string;
  extensionStatusId: number;
  extensionStatus: null | string;
  startDate: string;
  endDate: string;
  duration: number;
  shiftId: number;
  shiftDescription: string;
  isExtensionFromPriorPlacementId: true;
  extensionOfPriorPlacementId: number;
  tla: boolean;
  placementStartDate: null | string;
  placementEndDate: null | string;
  placementDuration: number;
  hoursPerShift: number;
  hoursPerWeek: number;
  notes?: string;
  payCycleStartDay?: string | null;
  payCycleEndDay?: string | null;
  payCycleShiftType?: string;
  payCycleShiftDetails?: IPlacementMarginPayCycleShiftDetail[];
}

export interface IPlacementMarginTreeViewBookingPeriod {
  placementId: number;
  bookingPeriodId: number | null;
}

export interface IPlacementMarginShiftListItem {
  shiftId: number;
  shiftDescription: string;
  rateShiftListId?: number;
  hoursPerWeek?: number;
  shiftTypeId?: number;
  shiftType?: string;
  orderBy?: number;
  hoursPerShift?: number;
  payCycleShiftType?: string;
}

export interface IPlacementMarginPayCycleShiftDetail {
  startDay: number;
  endDay: number;
  startDayName: string;
  endDayName: string;
  shiftTypeId: number;
  shiftType: string;
}

export interface IPlacementMarginToolScenario {
  addScenario: IPlacementMarginAddScenario;
  addExtension?: IPlacementMarginAddExtension;
  marginDetails?: IPlacementMarginDetailsResponse[];
  bookingPeriod?: IPlacementMarginDetailsResponse;
  selectedScenario?: IPlacementMarginDetailsResponseScenario;
  shiftDetails?: ITypeAheadOption[];
  createdScenarioId?: number;
  selectedEditScenario?: IPlacementMarginAddScenarioForm;
  gsaCalculatedValues?: IPlacementMarginGsaHousingDetailsSuymmaryResponse;
  scenarioModal: { modalStatus: boolean; modalName: string };
  deletedSplits?: IPlacementMarginScenarioSplit[];
  scenarioCreateUpdateResponse?: IPlacementMarginUpdateResponse;
  selectedMarginDetail?: IPlacementMarginDetailsResponse;
  scenariosTreeView: IPlacementMarginDetailsResponse[];
  selectedSearchPlacement?: {
    placementId: number;
    removed: boolean;
    candidateFirstName?: string;
    candidateLastName?: string;
  };
  shouldFeatchScenarioCalculate?: boolean | false;
  selectedTreeViewBookingPeriod?: IPlacementMarginTreeViewBookingPeriod;
  isPageLoaded?: boolean | false;
  isSaveTriggered?: boolean | false;
  isCancelTriggered?: boolean | false;
  shouldShowOrderIdModifiedDialog?: boolean | false;
  addEditScenarioModelData?: IPlacementMarginAddScenarioForm | null | undefined;
  isGroupUpdateInprogress?: boolean | false;
  marginOverTimeHourlyRates?: IPlacementMarginOverTimeHourlyRateItem[];
  peopleSoftValues?: IPeopleSoftValues[];
}

export interface IPlacementMarginOverTimeHourlyRateItem {
  scenarioId?: number;
  splitId?: number;
  payOvertimeLimitWeek?: number;
  payOverTimeLimitBiWeekly?: number;
  payOvertimeLimitDay?: number;
  payDoubletimeLimitWeek?: number;
  payDoubleTimeLimitBiWeekly?: number;
  payDoubletimeLimitDay?: number;
  payOvertimeHours?: number;
  payDoubletimeHours?: number;
  payPremiumHours?: number;
}

export interface IPlacementMarginDetailsResponse {
  placementId: number;
  placementStartDate?: Date;
  placementEndDate?: Date;
  placementDuration?: number;
  facility: IPlacementMarginFacility;
  travelerId?: number;
  candidateNameFirst: string;
  candidateNameMiddle: string;
  candidateNameLast: string;
  candidateNameGoesBy: string;
  brandId?: number;
  brand: string;
  amnDivisionTypeId?: number;
  amnDivisionType?: string;
  orderId?: number;
  orderTypeId?: number;
  orderType?: string;
  originalOrderId?: number;
  isOrderIdModified: boolean;
  isSkillSetModified: boolean;
  isBaseDetailsModified: boolean;
  disciplineId?: number;
  discipline?: string;
  specialtyId?: number;
  specialty?: string;
  subSpecialtyId?: number;
  subSpecialty?: string;
  originalDisciplineId?: number;
  originalSpecialtyId?: number;
  originalSubSpecialtyId?: number;
  shiftId?: number;
  shift: string;
  payCycleStartDayNum?: number;
  payCycleStartDay?: string;
  payCycleEndDayNum?: number;
  payCycleEndDay?: string;
  isPerDiemValuesValid: boolean;
  isScenarioExtention: boolean;
  extensionNumber?: number;
  isExtensionOfPriorPlacement: boolean;
  extensionOfPriorPlacementId?: number;
  isExtensionPlacementValid: boolean;
  bookingPeriodId?: number;
  bookingPeriodStartDate?: Date;
  bookingPeriodEndDate?: Date;
  bookingPeriodDuration?: number;
  packageName: string;
  recruiter: IPlacementMarginEmployee;
  accountManager?: IPlacementMarginEmployee;
  isMostRecentBookingPeriod: boolean;
  hasApprovedScenario: boolean;
  candidateSkillSets?: IPlacementMarginCandidateSkillSet[];
  scenarios: IPlacementMarginDetailsResponseScenario[];
  payCycleShiftType?: string;
  payCycleShiftDetails?: IPlacementMarginPayCycleShiftDetail[];
  shiftList?: IPlacementMarginShiftListItem[];
}

export interface IPlacementMarginCandidateSkillSet {
  disciplineId?: number | null;
  disciplineAbbr: string;
  specialtyId?: number | null;
  specialtyAbbr: string;
  subSpecialtyId?: number | null;
  subSpecialtyAbbr: string;
  status: string;
}

export interface IPlacementMarginFacility {
  facilityId?: number;
  facilityName: string;
  facilityAddress1: string;
  facilityAddress2: string;
  facilityState: string;
  facilityCity: string;
  facilityCounty?: string;
  facilityZip?: string;
  facilityLongitude?: number;
  facilityLatitude?: number;
  facilityCountry?: string;
  facilityRegionId?: number;
}

export interface IPlacementMarginEmployee {
  employeeId?: number;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
}

export interface IPlacementMarginDetailsResponseScenario {
  placementId: number;
  bookingPeriodId?: number;
  scenarioId?: number;
  scenarioName: string;
  scenarioStatusId?: number;
  scenarioStatus: string;
  orderId?: number;
  originalOrderId?: number;
  orderTypeId?: number;
  isOrderIdModified: boolean;
  isSkillSetModified: boolean;
  isBaseDetailsModified: boolean;
  disciplineId?: number;
  specialtyId?: number;
  subSpecialtyId?: number;
  originalDisciplineId?: number;
  originalSpecialtyId?: number;
  originalSubSpecialtyId?: number;
  tla?: boolean;
  createdUserId?: number;
  createdUserFirst: string;
  createdUserLast: string;
  createdDateAt?: Date;
  updatedUserId?: number;
  updatedUserFirst: string;
  updatedUserLast: string;
  updatedDateAt?: Date;
  grossMargin?: number;
  grossProfit?: number;
  revenue?: number;
  negotiatedContributionMargin: string;
  approvedUserId?: number;
  approvedUserFirst: string;
  approvedUserLast: string;
  approvedDateAt?: Date;
  approvedReasonId?: string;
  verifiedUserId?: number;
  verifiedUserFirst: string;
  verifiedUserLast: string;
  verifiedDateAt?: Date;
  verifiedReasonId?: number;
  notes: string;
  payCycleStartDayNum?: number;
  payCycleStartDay?: string;
  payCycleEndDayNum?: number;
  payCycleEndDay?: string;
  isPerDiemValuesValid: boolean;
  interimPayPackageTimeOffId?: number;
  assignment: IPlacementMarginAssignmentDetails;
  timestamp?: string;
  insuranceEffectiveDate?: string;
  insuranceWaitingPeriod?: number;
  isDefaultScenario: boolean;
  isMostRecentBookingPeriod: boolean;
  hasApprovedScenario: boolean;
  weeklyGrossPay?: number;
  splits: IPlacementMarginDetailsResponseScenarioSplitItem[];
}

export interface IPlacementMarginDetailsResponseScenarioSplitItem {
  id?: string;
  placementId: number;
  bookingPeriodId?: number;
  scenarioId?: number;
  splitId?: number;
  effectiveStartDate?: Date;
  effectiveEndDate?: Date;
  payCycleStartDayNum?: number;
  payCycleStartDay?: string;
  payCycleEndDayNum?: number;
  payCycleEndDay?: string;
  splitStartDayNum?: number;
  splitStartDay?: string;
  splitEndDayNum?: number;
  splitEndDay?: string;
  isPerDiemValuesValid: boolean;
  billRate?: number;
  contractRegularBillRate?: number;
  overtime?: number;
  holiday?: number;
  callback?: number;
  billGuaranteedHours?: number;
  billAmountPerMile?: number;
  payAmountPerMile?: number;
  splitPlacementId?: number;
  housingCoPay?: number;
  lodgingPerDiem?: number;
  standardFurniture?: number;
  housingTypeId?: number;
  housingType?: string;
  earlyMoveInDays?: number;
  earlyMoveInDaysWaived?: number;
  earlyMoveInCostPerDay?: number;
  lateMoveOutDays?: number;
  lateMoveOutDaysWaived?: number;
  lateMoveOutCostPerDay?: number;
  mealPerDiem?: number;
  cellPhoneStipend?: number;
  tlaMealAllowance?: number;
  tlaCarAllowance?: number;
  tlaShiftCompletionBonus?: number;
  shiftId?: number;
  shift?: string;
  hoursPerWeek?: number;
  hoursPerShift?: number;
  healthInsuranceTypeId?: number;
  healthInsuranceType?: string;
  isWaitingPeriodBenefit?: boolean;
  tlaCellPhoneStipend?: number;
  vms?: number;
  other?: number;
  billDoubletimeRate?: number;
  billOvertimeFactor?: number;
  billCallBackFactor?: number;
  billDoubletimeFactor?: number;
  billHolidayFactor?: number;
  billOnCallRate?: number;
  billCharge?: number;
  contractChargeAmount?: number;
  billPreceptor?: number;
  contractShiftId?: number;
  contractShiftDescription?: string;
  orientationHours?: number;
  isVoidOrientationHours?: boolean;
  payRate?: number;
  payrollRegularPayRate?: number;
  minPayRate?: number;
  payOvertimeFactor?: number;
  payCallBackFactor?: number;
  payDoubletimeFactor?: number;
  additionalPremiumPay?: object;
  payHolidayFactor?: number;
  payOnCallRate?: number;
  payGuaranteedHours?: number;
  payCharge?: number;
  payrollChargeAmount?: number;
  payPreceptor?: number;
  payrollShiftId?: number;
  payrollShiftDescription?: string;
  csfSupervisorCosts?: number;
  additionalCostMiscellaneousAmount?: number;
  additionalCostMiscellaneousDescription?: string;
  furnitureCoPay?: number;
  isEarlyMoveIn?: boolean;
  isLateMoveOut?: boolean;
  earlyMoveInDate?: Date;
  lateMoveOutDate?: Date;
  rentCost?: number;
  utilities?: number;
  rentOverrideNot?: string;
  miscellaneousFurnitureDescription?: string;
  orientationFactor?: number;
  orientationRate?: number;
  orientationOverrideUserId?: number;
  orientationOverrideFirst?: string;
  orientationOverrideLast?: string;
  orientationOverrideDate?: Date;
  standardFurnitureOriginal?: number;
  utilitiesOriginal?: number;
  rentCostOriginal?: number;
  furnitureCosts: IPlacementMarginFurnitureCost[];
  moveInDate?: Date;
  moveOutDate?: Date;
  standardMinPayRate?: number;
  standardNewGradPayRate?: number;
  standardTlaMinPayRate?: number;
  standardTlaNewGradPayRate?: number;
  standardTeletherapy?: number;
  payOvertimeLimitWeek?: number;
  payOverTimeLimitBiWeekly?: number;
  payOvertimeLimitDay?: number;
  payDoubletimeLimitWeek?: number;
  payDoubleTimeLimitBiWeekly?: number;
  payDoubletimeLimitDay?: number;
  payOvertimeHours?: number;
  payDoubletimeHours?: number;
  payPremiumHours?: number;
  weeklyGrossPay?: number;
  isAlliedTrue: boolean;
  isAssignmentSplit: boolean;
  insurance?: IInsurance;
}

export interface IPlacementMarginFurnitureCost {
  id?: number;
  description: string;
  standardCost?: number;
  costToTraveler?: number;
  quantity: number;
  include?: boolean;
}

export interface IPlacementMarginPayPackageTimeOffItem {
  timeOffId?: number;
  startDate?: Date;
  endDate?: Date;
  days?: number;
  hours?: number;
  scenarioId?: number;
  splitId?: number;
  approvedBy: string;
}

export interface IPlacementMarginScenarioSplitPayPackageDetailsValue {
  scenarioId?: number;
  splitId?: number;
  categoryId?: number;
  category: string;
  subCategoryId?: number;
  subCategory: string;
  pickListId?: number;
  pickListDescription: string;
  payPackageValues: Record<string, any>;
}

export interface IPlacementMarginAssignmentDetails {
  timeOffs: IPlacementMarginPayPackageTimeOffItem[];
  travel: IPlacementMarginDetailsResponseScenarioTravel;
  payPackageDetailsValues: IPlacementMarginDetailsResponseScenarioSplitPayPackageDetailsValue[];
}

export type IPlacementMarginDetailsResponseScenarioTravel = {
  arrivingTravel?: number;
  arrivalAmountPerMile?: number;
  endingTravel?: number;
  endingAmountPerMile?: number;
  interimTravel?: number;
  interimAmountPerMile?: number;
  amnFlight?: number;
  amnRentalCar?: number;
};

export type IPlacementMarginDetailsResponseScenarioSplitPayPackageDetailsValue = {
  scenarioId?: number;
  splitId?: number;
  categoryId?: number;
  category?: string;
  subCategoryId?: number;
  subCategory?: string;
  pickListId?: number;
  pickListDescription?: string;
  payPackageValues: IPlacementMarginPayPackageValues;
};

export interface IPlacementMarginPayPackageItem {
  category: string;
  categoryId: number;
  payPackageValues: IPlacementMarginPayPackageValues;
  pickListDescription: string;
  pickListId: number;
  scenarioId: number;
  splitId: number;
  subCategory: string;
  subCategoryId: number;
}

interface IPlacementMarginPayPackageValues {
  amount: number;
  description: string;
  receiptsRequiredToPay: boolean;
}

export enum MarginEntityType {
  Placement = 'placement',
}
